import { marked } from 'marked'

marked.setOptions({
    gfm: true,
    breaks: true,
})

export const renderLegalMarkdown = (markdown: string) => marked.parse(markdown) as string
